import { useSessionContext } from '@/contexts/session/context';
import { Card } from '../card';
import styles from './index.module.scss';

const Privacy = () => {
  const {
    userSettings: { userSettingsState, setUserSettings },
  } = useSessionContext();

  const data = useMemo(
    () => [
      {
        title: 'Privacy',
        description:
          ' All messages in chats you start will be automatically deleted for everyone at some point after they have been sent.',
        data: [
          {
            key: '1',
            title: 'Messages',
            description: 'Who can send me messages?',
            extra: (
              <Select
                style={{ width: 170 }}
                placeholder="Select"
                value={userSettingsState?.message_in}
                options={[
                  {
                    label: 'Everybody',
                    value: '1',
                  },
                ]}
                onChange={(value) => {
                  setUserSettings({ message_in: value });
                }}
              />
            ),
          },
          {
            key: '2',
            title: 'Calls',
            description: 'Who can call me',
            extra: (
              <Select
                style={{ width: 170 }}
                value={userSettingsState?.call_in}
                options={[
                  {
                    label: 'Everybody',
                    value: '1',
                  },
                  {
                    label: 'Nobody',
                    value: '2',
                  },
                ]}
                onChange={(value) => {
                  setUserSettings({ call_in: value });
                }}
              />
            ),
          },
          {
            key: '3',
            title: 'Search at Global',
            extra: (
              <Switch
                checked={userSettingsState?.global_search === '1'}
                onChange={(value) => {
                  setUserSettings({
                    global_search: value ? '1' : '2',
                  });
                }}
              />
            ),
          },
        ],
      },
      {
        description:
          ' All messages in chats you start will be automatically deleted for everyone at some point after they have been sent.',
        data: [
          {
            key: '1',
            title: 'Read Receipts',
            extra: (
              <Switch
                disabled
                checked
                onChange={(e) => {
                  console.log(e);
                }}
              />
            ),
          },
          {
            key: '2',
            title: 'Typing Indicators',
            extra: (
              <Switch
                disabled
                checked={false}
                onChange={(e) => {
                  console.log(e);
                }}
              />
            ),
          },
        ],
      },
    ],
    [
      setUserSettings,
      userSettingsState?.call_in,
      userSettingsState?.global_search,
      userSettingsState?.message_in,
    ]
  );

  return (
    <div className={styles.container}>
      <div className={styles.title}>Privacy</div>
      <div className={styles.content}>
        {data.map((item, index) => {
          return (
            <Card
              className={styles.card}
              key={index}
              title={item.title}
              description={item.description}
              data={item.data}
            ></Card>
          );
        })}
      </div>
    </div>
  );
};
export default Privacy;
